import React from 'react';
import {observer} from 'mobx-react';
import {Panel, ActionLink, Label} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import EditContactInfoModal from './EditContactInfoModal';
import {t} from 'shared/core';

const ContactInfo = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <Panel>
      <Panel.Header title={t('employees.profile.personal.Contact Information')}>
        {uiState.editDataPermission('::PERSONAL_INFORMATION') && <ActionLink onClick={() => uiState.openContactInfoModal()}>
          <FormattedMessage id='employees.profile.personal.Edit'/>
        </ActionLink>}
      </Panel.Header>
      <div className='col-12 sm-col-10 pt1'>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Work Email'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='workEmail'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Personal Email'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='personalEmail'/>
          </div>
        </div>
      </div>
      <EditContactInfoModal uiState={uiState} />
    </Panel>
  );
});

export default ContactInfo;
